import { Editor } from '@tiptap/react'
import { Flex } from 'antd'

import { OrderedListButton } from './OrderedListButton'
import { TaskListButton } from './TaskListButton'
import { UnorderedListButton } from './UnorderedListButton'

type Props = {
  editor: Editor
}

export const MenuListButtons = ({ editor }: Props) => {
  return (
    <Flex gap="8px">
      <OrderedListButton editor={editor} />
      <UnorderedListButton editor={editor} />
      <TaskListButton editor={editor} />
    </Flex>
  )
}
